import React, { useContext, useEffect, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";

import { JobsContext, SearchContext } from "context/providers";
import Applications from "components/Applications";

const UserSearch = ({ signOut }) => {
  const { jobOpp, clearJob } = useContext(JobsContext);

  const {
    clearSearchState,
    handleReadyForSearch,
    handlePageIsLoaded,
    setHits,
    pageIsLoaded,
  } = useContext(SearchContext);

  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(window.location.hash.split("?")[1]);
  const searchQuery = queryParams.get("search");

  const initialMountRef = useRef(false);

  useEffect(() => {
    if (jobOpp?.id) {
      clearJob();
    }

    return () => {
      handlePageIsLoaded(false);
      handleReadyForSearch(false);
      setHits([]);
      clearSearchState({ isUnMounting: true });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cleanUpSearchParams = () => {
    // Deleting query params to not persist state in the URL
    queryParams.delete("search");
    const newUrl =
      location.pathname +
      (queryParams.size > 0 ? `?${queryParams.toString()}` : "");
    history.replace(newUrl);
  };

  useEffect(() => {
    if (!jobOpp?.id) {
      // InstantSearch may still setting state from the unmount of job page
      setTimeout(() => {
        //search query logic exists here, because this useEffect always resets any state logic
        //We should be able to move this logic to searchContext if we can remove this setTimeout in the future
        if (searchQuery) {
          cleanUpSearchParams();
        }
        clearSearchState({
          isUnMounting: true,
          urlParamData: searchQuery
            ? {
                customSearchQuery: searchQuery,
                basicSearch: true,
              }
            : null,
        });

        handleReadyForSearch(true);
      }, 150);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobOpp?.id]);

  // Initial state is set and widgets have been triggered
  // handle pageIsLoaded
  useEffect(() => {
    if (pageIsLoaded && !initialMountRef.current) {
      initialMountRef.current = true;
      setTimeout(() => {
        handleReadyForSearch(true);
      }, 1500);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIsLoaded]);

  useEffect(() => {
    if (pageIsLoaded && searchQuery) {
      cleanUpSearchParams();
      clearSearchState({
        isUnMounting: true,
        urlParamData: {
          customSearchQuery: searchQuery,
          basicSearch: true,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  if (!pageIsLoaded) {
    return (
      <div className="flex justify-center pt-8">
        <span className="loader"></span>
      </div>
    );
  }

  return <Applications signOut={signOut} />;
};

export default UserSearch;
